module.exports = __webpack_public_path__ + "checkbox-01.7e72002067c9047c205fdb3521176196.png";